/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Button as AntButton, Col, Input, Modal, Row, Skeleton, Table, Tooltip, Typography } from 'antd';
import { Button as CrcButton, Spinner } from '@crc-evans/ui-components';
import {
  MoreOutlined,
  RightCircleOutlined,
  ArrowLeftOutlined,
  EditOutlined,
  DeleteOutlined,
  SettingOutlined,
  ToolOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import MaintenanceTypes from './MaintenanceTypes';
import { connect } from 'react-redux';
import { get } from 'lodash';
import {
  deleteAdminEquipTypes,
  fetchAdminEquipTypes,
  fetchAdminPihEquipTypes,
} from '../../redux/admin/equipmentTypes/action';
import EquipmentsNo from './EquipmentsNo';
import { fetchAdminEquipSno, fetchAdminEquipTypeSno } from '../../redux/admin/equipmentSno/action';
import CommonAGGridTable from '../AG Grid/CommonAGGridTable';
import ExpandableText from '../common/ExpandableText';
import { useHeatStyleColumnFacets } from '../technical/heatStyleColumnFacets';
import { ChevronLeft } from 'lucide-react';

const { Text, Title } = Typography;

const ASSET_EQUIPMENT_FACET_KEYS = ['pihEquipmentType', 'pihEquipmentTypeCategory'];

const EquipmentTypes = (props) => {
  const {
    openPage,
    setOpenPage,
    setOpenModel,
    openModal,
    checkOpen,
    setChecksOpen,
    equipTypeList,
    setEquipTypeList,
    adminEquipTypesLoading,
    equipmentType,
    setEquipmentType,
    equipTypeForm,
    editModelValue,
    setEditModelValue,
    setEditRecord,
    editRecord,
    OnclearEquipType,
    isModernPage = false,
    onDeleteEquipType,
    isEquipTypeDeleteLoading,
    adminEquipTypeSnoData,
    adminEquipTypeSnoLoad,
    onGetEquipSno,
    equipTypeSearchForm,
    clear,
    setClear,
    adminEquipTypesTotalCount,
    onGetPihEquipmentTypes,
    paginationClear,
    setPaginationClear,
    searchCriteria,
    setSearchCriteria,
  } = props;

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteEquipId, setDeleteEquipId] = useState('');
  const [equipmentTypeId, setEquipmentTypeId] = useState();
  const [equipmentTypeName, setEquipmentTypeName] = useState();
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [currentPagesize, setCurrentPagesize] = useState(10000);

  const [adminEquipTypeSnoDataList, setAminEquipTypeSnoDataList] = useState([]);
  const addEquipmentHandlerRef = useRef(null);
  const registerAddEquipment = useCallback((handler) => {
    addEquipmentHandlerRef.current = handler;
  }, []);

  const [columnDefs, setColumnDefs] = useState([]);
  const [layoutSave, setLayoutSave] = useState(false);
  const [layoutLoad, setLayoutLoad] = useState(false);
  const [isPivotMode, setIsPivotMode] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [columnFilters, setColumnFilters] = useState({
    pihEquipmentTypeCategory: '',
    pihEquipmentType: '',
  });
  const [maintenanceChecksSearch, setMaintenanceChecksSearch] = useState('');
  /** Modern table only: match Communications / Shipping pagination (default 20 / page) */
  const [modernTablePage, setModernTablePage] = useState(1);
  const [modernTablePageSize, setModernTablePageSize] = useState(20);
  const [sortKey, setSortKey] = useState('pihEquipmentType');
  const [sortDesc, setSortDesc] = useState(false);

  useEffect(() => {
    setModernTablePage(1);
  }, [columnFilters.pihEquipmentTypeCategory, columnFilters.pihEquipmentType]);

  const handleColumnFilterChange = useCallback((key, value) => {
    setColumnFilters((prev) => ({ ...prev, [key]: value }));
    setModernTablePage(1);
  }, []);

  const equipFacetListRef = useRef([]);
  equipFacetListRef.current = equipTypeList || [];

  const fetchEquipFacetRows = useCallback(async () => {
    const list = equipFacetListRef.current;
    return Array.isArray(list) ? [...list] : [];
  }, []);

  const searchCriteriaForFacets = useMemo(() => ({}), []);

  const { columnSelectedValues, applyFacetClientFilter, renderTextColumnFilterTrigger } =
    useHeatStyleColumnFacets({
      enabled: isModernPage,
      filterableColumns: ASSET_EQUIPMENT_FACET_KEYS,
      listCount: (equipTypeList || []).length,
      projectList: equipTypeList || [],
      searchCriteria: searchCriteriaForFacets,
      columnFilters,
      onColumnFilterChange: handleColumnFilterChange,
      fetchFacetRows: fetchEquipFacetRows,
    });

  const handleSortClick = (field) => {
    setSortKey((prev) => {
      if (prev === field) {
        setSortDesc((d) => !d);
        return prev;
      }
      setSortDesc(false);
      return field;
    });
  };

  const renderSortCaret = (field) =>
    sortKey === field ? (
      sortDesc ? (
        <CaretDownOutlined className="equipment-type-sort-dir-icon" aria-hidden />
      ) : (
        <CaretUpOutlined className="equipment-type-sort-dir-icon" aria-hidden />
      )
    ) : (
      <CaretUpOutlined
        className="equipment-type-sort-dir-icon doc-control-sort-caret-inactive"
        aria-hidden
      />
    );

  const generateColumns = async () => {
    const columnDefs = [
      {
        headerName: '  S.No',
        field: 'sno',
        maxWidth: 150,
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'center' },
        suppressMovable: true,
        lockPosition: true,
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Equipment Type',
        field: 'pihEquipmentType',
        width: 200,
        sortable: true,
        filter: true,
        headerClass: 'ag-center-header',

        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Equipment Category',
        field: 'pihEquipmentTypeCategory',
        width: 200,
        sortable: true,
        filter: true,
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Actions',
        field: 'editDelete',
        width: 200,
        pinned: 'right',
        suppressMovable: true,
        headerClass: 'ag-center-header',
        cellRenderer: (params) => {
          const record = params.data;
          return (
            <div className="tableIcons">
              <Tooltip
                title="Maintenance Management"
                placement="left"
              >
                <ToolOutlined
                  className="icon-18"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={() => {
                    setChecksOpen(true);
                    setOpenPage('maintenance');
                    setEquipmentTypeName(record.pihEquipmentType);
                    equipTypeSearchForm.setFieldsValue({
                      equipmentType: record.pihEquipmentType,
                    });
                  }}
                ></ToolOutlined>
              </Tooltip>
              <Tooltip
                title="Update"
                placement="left"
              >
                <EditOutlined
                  className="icon-18"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={() => setEditModel(record)}
                />
              </Tooltip>
              <Tooltip
                title="Delete"
                placement="top"
              >
                <DeleteOutlined
                  className="icon-18"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={() => {
                    setDeleteModal(true);
                    setDeleteEquipId(record);
                  }}
                />
              </Tooltip>
              <Tooltip
                title="Equipments"
                placement="top"
              >
                <RightCircleOutlined
                  className="icon-22"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={async () => {
                    setChecksOpen(true);
                    setOpenPage('equipment');
                    equipTypeSearchForm.setFieldsValue({
                      equipmentType: record.pihEquipmentType,
                    });
                    setEquipmentTypeName(record.pihEquipmentType);
                    await onGetEquipSno({
                      pihEquipmentType: record.pihEquipmentType,
                    });
                  }}
                />
              </Tooltip>
            </div>
          );
        },
        cellStyle: { textAlign: 'center' },
        filter: false,
        suppressMovable: true,
      },
      // {
      //     headerName: 'Maintenance',
      //     field: 'maintenance',
      //     width: 200,
      //     cellRenderer: (params) => {
      //         const record = params.data;
      //         return (
      //             <div className='tableIcons'>
      //                 <Button
      //                     className='maintenance_mng_Btn'
      //                     onClick={() => {
      //                         setChecksOpen(true);
      //                         setOpenPage('maintenance');
      //                         setEquipmentTypeName(record.pihEquipmentType);
      //                         equipTypeSearchForm.setFieldsValue({
      //                             equipmentType: record.pihEquipmentType
      //                         });
      //                     }}
      //                 >
      //                     Maintenance Management
      //                 </Button>
      //             </div>
      //         );
      //     },
      //     cellStyle: { textAlign: 'center' },
      //     filter: false,
      //     suppressMovable: true,
      // },
    ];

    // console.log(columnList, columnDefs);
    setColumnDefs(columnDefs);
    return columnDefs;
  };
  useEffect(() => {
    generateColumns();
  }, []);

  useEffect(() => {
    (async () => {
      var obj = {
        pageSize: currentPagesize,
        pageNumber: searchCriteria != '' ? 1 : currentPageNumber,
        searchKey: searchCriteria,
      };

      await onGetPihEquipmentTypes(obj);
      // await generateColumns()
    })();

    //console.log(searchText)
  }, [searchCriteria]);

  useEffect(() => {
    if (adminEquipTypeSnoData) setAminEquipTypeSnoDataList(adminEquipTypeSnoData);

    //console.log(searchText)
  }, [adminEquipTypeSnoData]);

  const typesListColumns = [
    {
      title: 'Equipment Types',
      dataIndex: 'pihEquipmentType',
      key: 'pihEquipmentType',
      align: 'left',
      // sorter: (a, b) => {return (a-b)},
      ellipsis: true,
    },
    {
      title: 'Actions',
      key: 'action',
      dataIndex: 'action',
      align: 'center',
      width: '150px',
      render: (text, record) => {
        return (
          <div className="tableIcons">
            <Tooltip
              title="Update"
              placement="left"
            >
              <EditOutlined
                className="icon-18"
                style={{ margin: '0 10px', color: '#ef314c' }}
                onClick={() => setEditModel(record)}
              />
            </Tooltip>
            <Tooltip
              title="Delete"
              placement="top"
            >
              {' '}
              <DeleteOutlined
                className="icon-18"
                style={{ margin: '0 10px', color: '#ef314c' }}
                onClick={() => {
                  setDeleteModal(true);
                  setDeleteEquipId(record);
                }}
              />
            </Tooltip>
          </div>
        );
      },
      align: 'center',
    },
    {
      key: 'action',
      dataIndex: 'action',
      align: 'center',
      width: '250px',
      render: (text, record) => {
        return (
          <div className="tableIcons">
            <AntButton
              className="maintenance_mng_Btn"
              onClick={() => {
                setChecksOpen(true);
                setOpenPage('maintenance');
                // setEquipmentTypeId(record.id);
                setEquipmentTypeName(record.pihEquipmentType);
                equipTypeSearchForm.setFieldsValue({ equipmentType: record.pihEquipmentType });
              }}
            >
              Maintenance Management
            </AntButton>
          </div>
        );
      },
      align: 'center',
    },
    {
      title: () => {
        return <MoreOutlined style={{ fontSize: '18px' }} />;
      },
      key: 'action',
      dataIndex: 'action',
      align: 'center',
      width: '100px',
      render: (text, record) => {
        return (
          <div className="tableIcons">
            <Tooltip
              title="Equipments"
              placement="top"
            >
              <RightCircleOutlined
                className="icon-22"
                onClick={async () => {
                  setChecksOpen(true);
                  setOpenPage('equipment');
                  equipTypeSearchForm.setFieldsValue({ equipmentType: record.pihEquipmentType });
                  setEquipmentTypeName(record.pihEquipmentType);
                  // setEquipmentTypeId(record.id);
                  console.log(record);
                  await onGetEquipSno({ pihEquipmentType: record.pihEquipmentType });
                }}
              />
            </Tooltip>
          </div>
        );
      },
      align: 'center',
    },
  ];

  /** Setting values for updating equipment types */
  const setEditModel = (record) => {
    setOpenModel(true);
    setEditRecord(record);
    setEditModelValue(true);
  };

  /** Resetting values on Closing Modal */
  const handleCancel = () => {
    setDeleteModal(false);
    setDeleteEquipId('');
  };

  /** Waiting to delete equipment type and close Modal */
  useEffect(() => {
    if (!isEquipTypeDeleteLoading) {
      setDeleteModal(false);
      setDeleteEquipId('');
      // OnclearEquipType();
      setClear(false);
      equipTypeSearchForm.resetFields();
      setPaginationClear(false);
    }
  }, [isEquipTypeDeleteLoading]);

  const modernTableColumns = [
    {
      title: (
        <span
          className="equipment-type-column-title equipment-type-column-title-sortable"
          role="button"
          tabIndex={0}
          onClick={(e) => {
            e.stopPropagation();
            handleSortClick('sno');
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleSortClick('sno');
            }
          }}
        >
          S.NO {renderSortCaret('sno')}
        </span>
      ),
      dataIndex: 'sno',
      key: 'sno',
      width: 80,
      align: 'center',
      render: (_, __, index) => (
        <span className="equipment-types-sno">
          {(modernTablePage - 1) * modernTablePageSize + index + 1}
        </span>
      ),
    },
    {
      title: () => (
        <div className="column-header-with-filter">
          <div className="column-header-text-wrapper spares-column-header-sortable">
            <span className="equipment-type-column-title">EQUIPMENT TYPE</span>
            <span
              className="custom-sort-icon"
              role="button"
              tabIndex={0}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleSortClick('pihEquipmentType');
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleSortClick('pihEquipmentType');
                }
              }}
            >
              {renderSortCaret('pihEquipmentType')}
            </span>
            {renderTextColumnFilterTrigger('pihEquipmentType')}
          </div>
          <div className="header-filter-input admin-mgmt-header-search">
            <div className="heat-profile-inline-field-shell heat-profile-inline-field-shell--sm heat-profile-header-inline-shell">
              <Input
                placeholder="Search..."
                value={columnFilters.pihEquipmentType || ''}
                onChange={(e) => handleColumnFilterChange('pihEquipmentType', e.target.value)}
                onClick={(e) => e.stopPropagation()}
                size="small"
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </div>
      ),
      dataIndex: 'pihEquipmentType',
      key: 'pihEquipmentType',
      ellipsis: true,
      render: (text) => <span className="equipment-types-name">{text}</span>,
    },
    {
      title: () => (
        <div className="column-header-with-filter">
          <div className="column-header-text-wrapper spares-column-header-sortable">
            <span className="equipment-type-column-title">EQUIPMENT CATEGORY</span>
            <span
              className="custom-sort-icon"
              role="button"
              tabIndex={0}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleSortClick('pihEquipmentTypeCategory');
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleSortClick('pihEquipmentTypeCategory');
                }
              }}
            >
              {renderSortCaret('pihEquipmentTypeCategory')}
            </span>
            {renderTextColumnFilterTrigger('pihEquipmentTypeCategory')}
          </div>
          <div className="header-filter-input admin-mgmt-header-search">
            <div className="heat-profile-inline-field-shell heat-profile-inline-field-shell--sm heat-profile-header-inline-shell">
              <Input
                placeholder="Search..."
                value={columnFilters.pihEquipmentTypeCategory || ''}
                onChange={(e) => handleColumnFilterChange('pihEquipmentTypeCategory', e.target.value)}
                onClick={(e) => e.stopPropagation()}
                size="small"
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </div>
      ),
      dataIndex: 'pihEquipmentTypeCategory',
      key: 'pihEquipmentTypeCategory',
      width: 220,
      ellipsis: true,
      render: (text) => (
        <Tooltip placement="topLeft" title={text || '—'}>
          <span className="equipment-types-name">{text ?? '—'}</span>
        </Tooltip>
      ),
    },
    {
      title: <span className="equipment-type-column-title">ACTIONS</span>,
      key: 'actions',
      width: 200,
      align: 'center',
      render: (_, record) => (
        <div className="equipment-types-actions">
          <Tooltip title="Maintenance Management" placement="left">
            <ToolOutlined className="equipment-type-action-icon" onClick={() => { setChecksOpen(true); setOpenPage('maintenance'); setEquipmentTypeName(record.pihEquipmentType); equipTypeSearchForm.setFieldsValue({ equipmentType: record.pihEquipmentType }); }} />
          </Tooltip>
          <Tooltip title="Update" placement="left">
            <EditOutlined className="equipment-type-action-icon" onClick={() => setEditModel(record)} />
          </Tooltip>
          <Tooltip title="Delete" placement="top">
            <DeleteOutlined className="equipment-type-action-icon" onClick={() => { setDeleteModal(true); setDeleteEquipId(record); }} />
          </Tooltip>
          <Tooltip title="Equipments" placement="top">
            <RightCircleOutlined className="equipment-type-action-icon" onClick={async () => { setChecksOpen(true); setOpenPage('equipment'); equipTypeSearchForm.setFieldsValue({ equipmentType: record.pihEquipmentType }); setEquipmentTypeName(record.pihEquipmentType); await onGetEquipSno({ pihEquipmentType: record.pihEquipmentType }); }} />
          </Tooltip>
        </div>
      ),
    },
  ];

  const tableDataSource = React.useMemo(() => {
    const list = (equipTypeList || []).map((item, index) => ({
      ...item,
      key: item.id != null ? item.id : index,
      sno: index + 1,
    }));
    let filtered = list;
    ASSET_EQUIPMENT_FACET_KEYS.forEach((facetKey) => {
      const sel = columnSelectedValues[facetKey];
      if (sel == null || sel.size === 0) {
        const term = (columnFilters[facetKey] || '').trim().toLowerCase();
        if (term) {
          filtered = filtered.filter((item) =>
            (item[facetKey] || '').toLowerCase().includes(term)
          );
        }
      }
    });
    filtered = applyFacetClientFilter(filtered);

    const sorted = [...filtered];
    sorted.sort((a, b) => {
      if (sortKey === 'sno') {
        const va = Number(a.sno) || 0;
        const vb = Number(b.sno) || 0;
        return sortDesc ? vb - va : va - vb;
      }
      const va = (a[sortKey] ?? '').toString();
      const vb = (b[sortKey] ?? '').toString();
      const cmp = va.localeCompare(vb, undefined, { sensitivity: 'base' });
      return sortDesc ? -cmp : cmp;
    });

    return sorted;
  }, [equipTypeList, columnFilters, columnSelectedValues, applyFacetClientFilter, sortKey, sortDesc]);

  return (
    <div>
      {!checkOpen ? (
        <div>
          {isModernPage ? (
            <div className="heat-profile-table-wrap">
              <Table
                className="heat-profile-table equipment-types-table"
                columns={modernTableColumns}
                dataSource={tableDataSource}
                rowKey={(record) => record.id != null ? record.id : record.pihEquipmentType}
                loading={{
                  spinning: equipTypeList.length === 0 || adminEquipTypesLoading,
                  indicator: <Spinner variant="inline" size="large" color="#00C9A7" />,
                }}
                pagination={{
                  current: modernTablePage,
                  pageSize: modernTablePageSize,
                  total: tableDataSource.length,
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '20', '50', '100'],
                  showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} items`,
                  onChange: (page, size) => {
                    setModernTablePage(page);
                    setModernTablePageSize(size || modernTablePageSize);
                  },
                }}
              />
            </div>
          ) : (
          <Row gutter={24}>
            <Col
              span={24}
              style={{ padding: '0px 12px 0' }}
            >
              <CommonAGGridTable
                rowData={equipTypeList}
                columnDefs={columnDefs}
                activeKeyLine="example-grid"
                isRawListLoading={equipTypeList.length === 0 || adminEquipTypesLoading}
                loadingMessage="Loading Equipment Types..."
                //onSelectionChanged={handleSelectionChanged}
              />
            </Col>
          </Row>
          )}
        </div>
      ) : (
        <div className={isModernPage ? 'heat-profile-asset-detail' : ''}>
          <div className={`back_equip${isModernPage ? ' back_equip-modern' : ''}`}>
            {isModernPage ? (
              <div className="back_equip-modern-inner">
                <a
                  href="#back"
                  className="heat-profile-page-back-link"
                  onClick={(e) => {
                    e.preventDefault();
                    setChecksOpen(false);
                    setOpenPage('');
                    if (!clear) {
                      equipTypeSearchForm.resetFields();
                      OnclearEquipType();
                      setAminEquipTypeSnoDataList([]);
                      setEquipmentTypeName('');
                      setMaintenanceChecksSearch('');
                    }
                  }}
                >
                  <div className="heat-profile-back-link">
                    <ChevronLeft size={16} /> Back
                  </div>
                </a>
                <div className="back_equip-modern-title-row">
                  <div className="back_equip-modern-title-wrap">
                    <ExpandableText
                      text={equipmentTypeName}
                      limit={180}
                      className="back_equip-modern-title back_equip-modern-expandable"
                      as="h2"
                    />
                  </div>
                  {openPage === 'equipment' && (
                    <AntButton
                      type="primary"
                      icon={<PlusOutlined />}
                      className="equipments-sno-add-btn"
                      onClick={() => addEquipmentHandlerRef.current?.()}
                    >
                      Add Equipment
                    </AntButton>
                  )}
                  {openPage === 'maintenance' && (
                    <div className="maintenance-checks-search-wrap">
                      <Input
                        placeholder="Search by equipment check name"
                        value={maintenanceChecksSearch}
                        onChange={(e) => setMaintenanceChecksSearch(e.target.value)}
                        style={{ minWidth: '280px', borderRadius: '8px' }}
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <Tooltip title={' Back'}>
                  <ArrowLeftOutlined
                    style={{ fontSize: '20px' }}
                    onClick={() => {
                      setChecksOpen(false);
                      setOpenPage('');
                      if (!clear) {
                        equipTypeSearchForm.resetFields();
                        OnclearEquipType();
                        setAminEquipTypeSnoDataList([]);
                        setEquipmentTypeName('');
                        setMaintenanceChecksSearch('');
                      }
                    }}
                  />
                </Tooltip>
                <Text style={{ fontSize: '16px', paddingLeft: '10px' }}>{equipmentTypeName}</Text>
                {openPage === 'maintenance' && (
                  <div className="maintenance-checks-search-wrap" style={{ marginLeft: 'auto' }}>
                    <Input
                      placeholder="Search by equipment check name"
                      value={maintenanceChecksSearch}
                      onChange={(e) => setMaintenanceChecksSearch(e.target.value)}
                    />
                  </div>
                )}
              </div>
            )}
          </div>

          {openPage === 'maintenance' ? (
            <div className={isModernPage ? 'heat-profile-table-wrap heat-profile-asset-detail-body' : ''} style={!isModernPage ? { marginTop: '-20px' } : undefined}>
              <MaintenanceTypes
                equipmentTypeId={equipmentTypeId}
                equipmentTypeName={equipmentTypeName}
                isModernPage={isModernPage}
                maintenanceChecksSearch={maintenanceChecksSearch}
              />
            </div>
          ) : (
            <div className={isModernPage ? 'heat-profile-table-wrap heat-profile-asset-detail-body' : ''}>
              <EquipmentsNo
                adminEquipTypeSnoData={adminEquipTypeSnoDataList}
                adminEquipTypeSnoLoad={adminEquipTypeSnoLoad}
                equipmentTypeName={equipmentTypeName}
                equipmentTypeId={equipmentTypeId}
                setEquipmentTypeId={setEquipmentTypeId}
                isModernPage={isModernPage}
                onRegisterAddEquipment={registerAddEquipment}
              />
            </div>
          )}
        </div>
      )}
      <Modal
        width="45vw"
        className={isModernPage ? 'heatprofile-modal' : 'pipeline-modal'}
        title="Delete Equipment Type"
        centered
        visible={deleteModal}
        footer={isModernPage ? [
          <CrcButton key="cancel" label="Cancel" variant="secondary" onClick={handleCancel} size="medium" />,
          <CrcButton key="apply" label={isEquipTypeDeleteLoading ? 'Deleting...' : 'Confirm'} variant="primary" onClick={() => onDeleteEquipType({ pihEquipmentType: deleteEquipId.pihEquipmentType })} disabled={isEquipTypeDeleteLoading} size="medium" />,
        ] : [
          <AntButton key="cancel" onClick={handleCancel}>Cancel</AntButton>,
          <AntButton key="apply" type="primary" onClick={() => onDeleteEquipType({ pihEquipmentType: deleteEquipId.pihEquipmentType })} loading={isEquipTypeDeleteLoading}>{isEquipTypeDeleteLoading ? 'Deleting' : 'Confirm'}</AntButton>,
        ]}
      >
        <div>
          <Text style={{ fontSize: '16px' }}>
            <p>
              Deleting Equipment Type will delete all the corresponding Equipments and related
              information.
            </p>
            Are you sure you want to delete{' '}
            <b style={{ color: '#EF314C' }}>{deleteEquipId && deleteEquipId.pihEquipmentType}</b>{' '}
            Equipment Type?
          </Text>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ adminEquipTypeReducer, adminEquipSnoReducer }) => {
  const adminEquipTypes = get(adminEquipTypeReducer, 'adminEquipTypes', []);
  const adminEquipTypesTotalCount = get(adminEquipTypeReducer, 'adminEquipTypesTotalCount', null);
  const adminEquipTypesLoading = get(adminEquipTypeReducer, 'adminEquipTypesLoading', false);
  const isEquipTypeDeleteLoading = get(adminEquipTypeReducer, 'isEquipTypeDeleteLoading', false);
  const adminEquipTypeSnoLoad = get(adminEquipSnoReducer, 'adminEquipTypeSnoLoad', false);
  const adminEquipTypeSnoData = get(adminEquipSnoReducer, 'adminEquipTypeSnoData', []);
  return {
    adminEquipTypes,
    adminEquipTypesLoading,
    isEquipTypeDeleteLoading,
    adminEquipTypeSnoData,
    adminEquipTypeSnoLoad,
    adminEquipTypesTotalCount,
  };
};

const mapDispatchToProps = {
  onDeleteEquipType: deleteAdminEquipTypes,
  onGetEquipSno: fetchAdminEquipTypeSno,
  onGetPihEquipmentTypes: fetchAdminPihEquipTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentTypes);
